(() => {
  let refreshTimeout = null;
  let lastCartCount = null;
  let lastRefreshTime = 0;

  window.addEventListener("abra:cart:changed", () => { 
    if (refreshTimeout) clearTimeout(refreshTimeout);

    refreshTimeout = setTimeout(() => {
      const now = Date.now();
      if (now - lastRefreshTime < 1000) return;
      
      Shopify.getCart((cart) => {
        if (lastCartCount !== cart.item_count) {
          lastCartCount = cart.item_count;
          lastRefreshTime = now;
          window.halo.updateSidebarCart(cart);
        }
      });
    }, 800);
  });
})();
